import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getProfile(pathname) {
  return await instance({ baseURL: baseURL }).get(pathname);
}

export async function updateProfile(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch(pathname, body);
}

export async function updatePictureProfile({
  pathname,
  body,
  onUploadProgress,
}) {
  return await instance({
    baseURL: baseURL,
  }).patch(pathname, body, { onUploadProgress });
}

// note: user api
export async function getUser(pathname, queryParams = "", extraHeaders = {}) {
  return await instance({
    baseURL: baseURL,
  }).get(pathname + queryParams, { headers: extraHeaders });
}

// note: update user roles api
export async function updateUserRoles(pathname, queryParams = "", body) {
  return await instance({
    baseURL: baseURL,
  }).patch(pathname + queryParams, body);
}

export async function getUserByRole(pathname) {
  return await instance({ baseURL: baseURL }).get(
    pathname,
  );
}

export async function createUser(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post(`/user` + pathname, body);
}

export async function updateUser(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch(`/user` + pathname, body);
}

export async function deleteUser(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/user" + pathname, { data: body });
}
